import React from 'react';
import ReactDOM from 'react-dom';
import PartnersSection from '../components/PartnersSection';
import { initializeI18n } from '../localization/i18n';
window.renderPartnersSection = (elementId, props) => {
  const el = document.getElementById(elementId);
  if (el) initializeI18n().then(() => ReactDOM.render(<PartnersSection props={props} />, el)).catch(() => {});
};
